if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const formData = new FormData(this.form);
      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: formData
      };

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            // Check if this is a recipient form validation error
            const recipientForm = this.querySelector('recipient-form');
            if (recipientForm && response.errors) {
              // Handle recipient form specific errors
              recipientForm.displayErrorMessage(response.description, response.errors);
            } else {
              // Handle general product form errors
              this.handleErrorMessage(response.description);
            }

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;

          // Reset recipient form if it exists
          const recipientForm = this.querySelector('recipient-form');
          if (recipientForm && typeof recipientForm.resetRecipientForm === 'function') {
            recipientForm.resetRecipientForm();
          }

          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          // For gift cards with recipient forms, open the cart instead of reloading
          if (recipientForm) {
            // Refresh cart state and open cart
            if (typeof window.renderCart === 'function' && typeof window.openCart === 'function') {
              // First refresh the cart state, then render and open cart
              if (typeof window.refreshCartState === 'function') {
                window.refreshCartState().then(() => {
                  return window.renderCart();
                }).then(() => {
                  window.openCart();
                }).catch(() => {
                  // Fallback to page reload if cart operations fail
                  window.location.reload();
                });
              } else {
                // Render updated cart content and open cart
                window.renderCart().then(() => {
                  window.openCart();
                }).catch(() => {
                  // Fallback to page reload if cart rendering fails
                  window.location.reload();
                });
              }
            } else {
              // Fallback to page reload if cart functions not available
              window.location.reload();
            }
          } else {
            // Just reload the page - this will show the updated cart
            window.location.reload();
          }
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage('An error occurred. Please try again.');
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}